import React from 'react';
import PageHeader from 'components/PageHeader/PageHeader';
import DataExtractionNavigationItems from 'pages/DataExtraction/Navigation/DataExtractionNavigationItems';

type Props = {
  backLink: string;
  hasExtractionTemplate: boolean;
  hasQualityTemplate: boolean;
  reviewerCanEditTemplate: boolean;
  isDe2?: boolean;
  usesNewTemplates?: boolean;
};

const ExtractionPageHeader = ({
  backLink,
  hasExtractionTemplate,
  hasQualityTemplate,
  reviewerCanEditTemplate,
  isDe2 = false,
  usesNewTemplates = false,
}: Props) => {
  const getRightContent = () => {
    // Don't render template buttons for DE1 legacy reviews
    if (!isDe2 && !usesNewTemplates) {
      return null;
    }

    return (
      <DataExtractionNavigationItems
        hasExtractionTemplate={hasExtractionTemplate}
        hasQualityTemplate={hasQualityTemplate}
        reviewerCanEditTemplate={reviewerCanEditTemplate}
        isDe2={isDe2}
      />
    );
  };

  return (
    <PageHeader
      headerText="Extraction"
      backLink={backLink}
      rightContent={getRightContent}
    />
  );
};

export default ExtractionPageHeader;
